// src/utils/taxesHelper.js
import { TAXES_PAR_DEFAUT } from './constantes';

let taxesCache = {
    tva_taux: TAXES_PAR_DEFAUT.TVA_TAUX,
    css_taux: TAXES_PAR_DEFAUT.CSS_TAUX,
    tva_active: TAXES_PAR_DEFAUT.TVA_ACTIVE,
    css_active: TAXES_PAR_DEFAUT.CSS_ACTIVE
};

export const initTaxes = async () => {
    try {
        const token = localStorage.getItem("token");
        const response = await fetch(
            'https://sawd.julesferry-ga.com/api/parametres.php?action=taxes',
            { headers: { 'Authorization': `Bearer ${token}` } }
        );
        
        if (response.ok) {
            const result = await response.json();
            if (result.data) {
                taxesCache = {
                    ...taxesCache,
                    ...result.data
                };
            }
        }
    } catch (err) {
        console.error("Erreur chargement taxes", err);
    }
};

export const getTVATaux = () => taxesCache.tva_taux;
export const getCSSTaux = () => taxesCache.css_taux;
export const isTVAActive = () => taxesCache.tva_active;
export const isCSSActive = () => taxesCache.css_active;

// Pour une utilisation asynchrone
export const getTaxes = () => taxesCache;